import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { Register, TreeComponent } from '@xanadu/core';
import { Node, Realm, Endpoint, Branch, Syndicate, Cast, Import } from '@xanadu/model';
import { NodeModel } from '@xanadu/model';
import { ImportMenuBuilder } from '@xanadu/menu';

@Component({
    selector: 'app-import-tree',
    templateUrl: './import-tree.component.html',
    styleUrls: ['./import-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('import-tree')
export class ImportTreeComponent extends TreeComponent<Import | Endpoint | Realm | Cast | Syndicate> {
    menuBuilder = inject(ImportMenuBuilder);
    menuPosition: any = { x: 0, y: 0 };

    protected override get nodeType(): string | undefined {
        return 'import';
    }

    onRealm() {
        const realm = new Realm(undefined);
        realm.name = 'new realm';
        this.addChild(realm);
    }

    onEndpoint() {
        const endpoint = new Endpoint(undefined);
        endpoint.name = 'new endpoint';

        this.addChild(endpoint);
    }

    onSyndicate() {
        const syndicate = new Syndicate(undefined);
        syndicate.name = 'new syndicate';
        this.addChild(syndicate);
    }

    onCast() {
        const cast = new Cast(undefined);
        cast.name = 'new cast';

        this.addChild(cast);
    }

    onPaste() {
        this.paste();
    }

    protected replace(node: Node, branch: Branch): Observable<Endpoint | Realm> {
        return this.dataService.replace<Endpoint | Realm>(node as any, branch);
    }

    protected dropOk(dragModel: NodeModel, dropModel: NodeModel): boolean {
        const dragNode = dragModel.node;
        const dropNode = dropModel.node as Branch;

        return dragNode.fit(dropNode);
    }
}
